import type { FC } from 'react'
import { PatientUser } from '~/shared/types'
import ProviderSearchContent from './ProviderSearchContent'
import { useProviderSearch } from './utils'
import { Loader } from '~/shared/ui'
import { useReferralDetails } from '~/entities/steerage'

interface ProviderSearchProps {
  patient: PatientUser
}

/** Provider Search tab. */
const ProviderSearch: FC<ProviderSearchProps> = props => {
  const { isPending: providerSearchIsLoading } = useProviderSearch()
  const { isLoading: referralDetailsIsLoading } = useReferralDetails()
  const isLoading = providerSearchIsLoading || referralDetailsIsLoading
  if (isLoading) return <Loader />
  return <ProviderSearchContent person={props?.patient.person} />
}

export default ProviderSearch
